import { j as t } from "../../../_virtual/jsx-runtime.js";
import { useState as d, useEffect as x } from "react";
import j from "../../atoms/BaseCard/index.js";
import u from "../../atoms/BaseCardHeader/index.js";
import v from "../ExpandableButton/index.js";
import { cn as b } from "../../../lib/utils.js";
const H = ({
  baseCardHeaderInfo: i,
  baseCardProps: m,
  children: l,
  toggleVariant: c = "transparent",
  extraHeaderContent: n,
  defaultExpanded: r = !1,
  onExpandChange: s,
  isLoading: p
}) => {
  const [o, e] = d(r);
  x(() => {
    e(r);
  }, [r]);
  const f = () => {
    const a = !o;
    e(a), s == null || s(a);
  };
  return /* @__PURE__ */ t.jsxs(j, { ...m, children: [
    /* @__PURE__ */ t.jsxs(u, { isLoading: p, ...i, children: [
      n,
      /* @__PURE__ */ t.jsx(
        v,
        {
          onExpand: f,
          isExpanded: o,
          toggleVariant: c
        }
      )
    ] }),
    /* @__PURE__ */ t.jsx(
      "div",
      {
        className: b(
          "overflow-hidden transition-all duration-500 ease-in-out",
          o ? "max-h-[900px] opacity-100 overflow-visible" : "max-h-0 opacity-0"
        ),
        children: l
      }
    )
  ] });
};
export {
  H as default
};
